import Butter from 'buttercms'
export const butter = Butter('7b7824d7440c9192f31c1237759a135e14595370')
